import * as XLSX from 'xlsx';
import FileSaver from "file-saver";

function delCloudDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params,
		}
		vueInstance.$http
			.post("delMysqlData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const delCloudDataRes = response.data;
				vueInstance.loading = false;
				console.log(delCloudDataRes);
				if (delCloudDataRes.status == 'success') {
					vueInstance.$message({
						message: `已成功删除${delCloudDataRes.delResult.affectedRows}条记录!`,
						type: "success"
					});
					resolve(delCloudDataRes);
				} else {
					vueInstance.$message({
						message: "记录删除失败!",
						type: "fail"
					});
					resolve(delCloudDataRes);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getRecordTotalFunction(vueInstance, options, funName, tableName, params) { //读取系统违规分类========
	const urlData = {
		funName: funName,
		tableName: tableName,
		data: params,
	};
	return new Promise((resolve, reject) => {
		vueInstance.$http
			.post("getMysqlData", urlData, {
				...options
			})
			.then(response => {
				const getSearchDataRes = response.data;
				vueInstance.loading = false;
				if (getSearchDataRes.status == 'success') {
					resolve(getSearchDataRes.totalData);
				} else {
					vueInstance.$message({
						message: `找不到相关信息!`,
						type: "fail"
					});
					resolve(getSearchDataRes.totalData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getSearchPageDataFunction(vueInstance, options, tableName, orderKey, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			orderKey: orderKey,
			data: params,
		}
		vueInstance.$http
			.post("getSearchPageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getSearchDataRes = response.data;
				vueInstance.loading = false;
				if (getSearchDataRes.status == 'success') {
					resolve(getSearchDataRes.fetchData);
				} else {
					vueInstance.$message({
						message: `找不到相关信息!`,
						type: "fail"
					});
					resolve(getSearchDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getLikeOrderDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params.urlData,
			startKey: params.startKey,
			startValue: params.startValue,
			orderType: params.orderType,
		}
		vueInstance.$http
			.post("getLikeOrderData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getTodayVacatePageData(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params.urlData,
			startKey: params.startKey,
			startValue: params.startValue,
			orderType: params.orderType,
			pageSize: params.pageSize,
			offset: params.offset,
		}
		vueInstance.$http
			.post("getTodayVacatePageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				console.log(getCloudDataRes)
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getBedRoomDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params.urlData,
			startKey1: params.startKey1,
			startKey2: params.startKey2,
			startKey3: params.startKey3,
			startValue1: params.startValue1,
			startValue2: params.startValue2,
			startValue3: params.startValue3,
			orderType: params.orderType,
		}
		vueInstance.$http
			.post("getBedRoomInfoData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				console.log(getCloudDataRes)
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getBedRoomPageDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params.urlData,
			startKey1: params.startKey1,
			startKey2: params.startKey2,
			startKey3: params.startKey3,
			startValue1: params.startValue1,
			startValue2: params.startValue2,
			startValue3: params.startValue3,
			orderType: params.orderType,
			pageSize: params.pageSize,
			offset: params.offset,
		}
		vueInstance.$http
			.post("getBedRoomInfoPageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				console.log(getCloudDataRes)
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getStartKeyPageDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params.urlData,
			startKey: params.startKey,
			startValue: params.startValue,
			orderType: params.orderType,
			pageSize: params.pageSize,
			offset: params.offset,
		}
		vueInstance.$http
			.post("getStartKeyPageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getSysPageDataFunction(vueInstance, options, tableName, orderKey, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			orderKey: orderKey,
			data: params,
		}
		vueInstance.$http
			.post("getSysPageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}


function getCloudPageDataFunction(vueInstance, options, tableName, orderKey, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			orderKey: orderKey,
			data: params,
		}
		vueInstance.$http
			.post("getMysqlPageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getOrderPageDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			orderKey: params.orderKey,
			pageSize: params.pageSize,
			offset: params.offset,
			data: params.urlData,
		}
		vueInstance.$http
			.post("getOrderPageData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getOrderCloudDataFunction(vueInstance, options, thisFunName, tableName, orderKey, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: thisFunName,
			tableName: tableName,
			orderKey: orderKey,
			data: params,
		}
		vueInstance.$http
			.post("getMysqlData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getSysDataFunction(vueInstance, options, thisFunName, tableName) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: thisFunName,
			tableName: tableName,
			data: 'null',
		}
		vueInstance.$http
			.post("getMysqlData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getMessagerInfoFunction(vueInstance, options, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: params.thisFunName,
			tableName: params.tableName,
			orderKey: params.orderKey,
			data: params.urlData,
		}
		vueInstance.$http
			.post("getMysqlData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}


function getCloudDataPublicFunction(vueInstance, options, thisFunName, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: thisFunName,
			tableName: tableName,
			data: params,
		}
		vueInstance.$http
			.post("getMysqlData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getFileListFunction(vueInstance, options, thisFunName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: thisFunName,
			data: params.urlData,
			startKey: params.startKey,
			startValue: params.startValue,
			pageSize: params.pageSize,
			offset: params.offset,
		}
		console.log(urlData);
		vueInstance.$http
			.post("getFileListData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function getCloudDataFunction(vueInstance, options, thisFunName, params) { //读取系统违规分类========
	const NoData = [];
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: thisFunName,
			data: params,
		}
		vueInstance.$http
			.post("getMysqlData", urlData, { //周次===========
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(NoData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function editCloudDataFunction(vueInstance, options, tableName, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		const urlData = {
			tableName: tableName,
			data: params,
		}
		vueInstance.$http
			.post("editMysqlData", urlData, {
				...options
			})
			.then(response => {
				const editCloudDataRes = response.data;
				if (editCloudDataRes.status == 'success') {
					vueInstance.$message({
						message: "数据更新成功!",
						type: "success"
					});
				} else {
					vueInstance.$message({
						message: "数据更新失败!",
						type: "warning"
					});
				}
				vueInstance.loading = false;
				resolve(editCloudDataRes);
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}

function addCloudDataFunction(vueInstance, options, thisFunName, params, urlDatabase) {
	if (!checkParamsComplete(vueInstance, params)) {
		return;
	};
	return new Promise((resolve, reject) => {
		const urlData = {
			funName: thisFunName,
			urlDatabase: urlDatabase,
			data: params,
		}
		vueInstance.$http
			.post("addMysqlData", urlData, {
				headers: {
					...vueInstance.options.headers
				}
			})
			.then(response => {
				console.log('数据上传结果:', response.data); // 添加调试信息
				vueInstance.loading = false;
				const addResult = response.data
				if (addResult.addResult == 'success') {
					vueInstance.$notify({
						message: '数据录入成功!',
						type: 'success',
						duration: 5000
					});
				}
				if (addResult.addResult == 'fail') {
					vueInstance.$notify({
						message: '数据录入失败!',
						type: 'fail',
						duration: 5000
					});
				}
				if (addResult.addResult == 'error') {
					vueInstance.$notify({
						message: '后端错误，数据录入失败!',
						type: 'error',
						duration: 5000
					});
				}
				resolve(response.data);
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				if (error.response) {
					const errorMessage = error.response.data.message || '后端错误，请稍后重试';
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
				reject(error)
			});
	});
}

function formatDate(urlDate, type) {
  let date = urlDate ? new Date(urlDate) : new Date()
  if (isNaN(date.getTime())) {
    console.warn('Invalid date:', urlDate)
    date = new Date()
  }
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const pad = (num) => String(num).padStart(2, '0')
  const dateSlash = `${year}/${pad(month)}/${pad(day)}`      // 2024/05/18
  const dateDash = `${year}-${pad(month)}-${pad(day)}`       // 2024-05-18
  const time = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}` // 13:53:12
  const isFirstHalf = month <= 6
  const startYear = isFirstHalf ? year - 1 : year
  const startTerm = isFirstHalf ? '第2学期' : '第1学期'
  const formatMap = {
    'ymd/': dateSlash,
    'ymd-': dateDash,
    'hms': time,
    'ymd/hms': `${dateSlash} ${time}`,
    'ymd-ms': `${dateDash} ${time}`,
    'md-': `${pad(month)}-${pad(day)}`,
    'startYear': startYear,
    'startTerm': startTerm
  }
  return formatMap[type] ?? dateSlash // 默认返回 ymd/ 格式
}

function checkParamsComplete2(vueInstance, params) {
	for (const key in params) {
		if (params[key] == null || params[key] == undefined || params[key] == '') {
			vueInstance.$message({
				message: '你所提交的信息不全，请检查后再提交!',
				type: 'warning'
			});
			return false; // 返回 false 表示检查失败
		}
	}
	return true; // 所有字段都已填写，返回 true
}

function checkParamsComplete(vueInstance, params) {
	for (const key in params) {
		if (params[key] == null || params[key] == undefined) {
			vueInstance.$message({
				message: '你所提交的信息不全，请检查后再提交!',
				type: 'warning'
			});
			return false; // 返回 false 表示检查失败
		}
	}
	return true; // 所有字段都已填写，返回 true
}

function exportExcel1(fileName) {
	var wb = XLSX.utils.table_to_book(document.querySelector('#exportTable1'))
	/* get binary string as output */
	var wbout = XLSX.write(wb, {
		bookType: 'xlsx',
		bookSST: true,
		type: 'array'
	})
	try {
		FileSaver.saveAs(new Blob([wbout], {
			type: 'application/octet-stream'
		}), fileName)
	} catch (e) {
		if (typeof console !== 'undefined') console.log(e, wbout)
	}
	return wbout
}

function exportExcel(fileName) {
	var wb = XLSX.utils.table_to_book(document.querySelector('#exportTable'))
	/* get binary string as output */
	var wbout = XLSX.write(wb, {
		bookType: 'xlsx',
		bookSST: true,
		type: 'array'
	})
	try {
		FileSaver.saveAs(new Blob([wbout], {
			type: 'application/octet-stream'
		}), fileName)
	} catch (e) {
		if (typeof console !== 'undefined') console.log(e, wbout)
	}
	return wbout
}

function confirmMessage(vm) {
	vm.$confirm('数据已成功导入数据库，是否立即查看?', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning'
	}).then(() => {
		vm.$message({
			type: 'success',
			message: '已确认操作！',
		});
		return true;
	}).catch(() => {
		vm.$message({
			type: 'info',
			message: '已取消操作!'
		});
		return false;
	});
}

function get2KeyPageDataFunction(vueInstance, options, params) { //读取系统违规分类========
	return new Promise((resolve, reject) => {
		vueInstance.$http
			.post("get2KeyPageDataFunction", params, {
				...options
			})
			.then(response => {
				const getCloudDataRes = response.data;
				console.log(getCloudDataRes)
				vueInstance.loading = false;
				if (getCloudDataRes.status == 'success') {
					resolve(getCloudDataRes.fetchData);
				} else {
					resolve(getCloudDataRes.fetchData);
				}
			})
			.catch(error => {
				vueInstance.loading = false; // 确保在出错时也停止加载状态
				console.log(error)
				reject(error); // 使用 reject 来传递错误
				if (error.response) {
					vueInstance.$message({
						message: "请求错误：" + error.response.data.message,
						type: "error"
					});
				} else {
					vueInstance.$message({
						message: "网络或程序异常：" + error.message,
						type: "error"
					});
				}
			});
	});
}
async function uploadImage() {
	if (!this.selectedFile) {
		this.uploadStatus = '请先选择图片';
		return;
	}
	const thisFile = this.selectedFile
	const schoolCode = sessionStorage.getItem("SchoolCode")
	let fpath = schoolCode + '/DeYuYun/';
	let urlParams =
		"?SecretKey=wLWuOXbVbsuLTnEzRiyw&ObjectPath=" +
		fpath;
	const formData = new FormData();
	formData.append('moralimage', this.selectedFile);
	try {
		const response = await fetch('https://www.wzdyy.com:8090/uploadimage' + urlParams, {
			method: 'POST',
			body: formData
		});
		if (response.ok) {
			this.uploadStatus = '图片上传成功';
			const responseData = await response.json();
			console.log(responseData.downUrl);
		} else {
			this.uploadStatus = '图片上传失败';
		}
	} catch (error) {
		this.uploadStatus = '上传过程中出现错误';
		console.error('上传错误:', error);
	}
}
async function handledNotification(insertData,e) {
	//this.loading5 = true;
	try {
		const response = await fetch('https://www.wzdyy.com:8089/message', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'MoralUser': '17117823260317243',
				'MoralKey': 'wLWuOXbVbsuLTnEzRiyw'
			},
			body: JSON.stringify(insertData),
			mode: 'cors' // 明确指定CORS模式
		});
		if (response.ok) {
			const responseData = await response.json();
			console.log(responseData);
			e.$message({
				message: responseData.message,
				type: responseData.data?'success':'warning'
			});

		} else {
			const errorText = await response.text();
			e.$message({
				message: `信息推送失败: ${response.status} ${errorText}`,
				type: 'warning'
			});
			console.error('推送失败详情:', response.status, errorText);
		}
	} catch (error) {
		e.$message({
			message: '信息推送过程中出现错误!',
			type: 'error'
		});
		console.error('信息推送错误:', error);
	} finally {
		//this.loading5 = false;
	}
}
function generateMID(){
	const date=new Date().toISOString().slice(0,10).replace(/-/g,'');
	let random='';
	while(random.length<10){
		random+=Math.random().toString(36).slice(2).toUpperCase();
	}
	random=random.slice(0,10);
	return date+random;
}
export const myFunctions = {
	generateMID,
	handledNotification,
	uploadImage,
	exportExcel,
	exportExcel1,
	formatDate,
	checkParamsComplete,
	getSearchPageDataFunction,
	getCloudPageDataFunction,
	getCloudDataFunction,
	addCloudDataFunction,
	editCloudDataFunction,
	delCloudDataFunction,
	checkParamsComplete2,
	getRecordTotalFunction,
	getCloudDataPublicFunction,
	getStartKeyPageDataFunction,
	getLikeOrderDataFunction,
	confirmMessage,
	getTodayVacatePageData,
	getSysPageDataFunction,
	getSysDataFunction,
	getMessagerInfoFunction,
	getOrderCloudDataFunction,
	getBedRoomPageDataFunction,
	getBedRoomDataFunction,
	getFileListFunction,
	getOrderPageDataFunction,
	get2KeyPageDataFunction,
};